import { forwardRef } from 'react';
import { Position } from 'reactflow';

import BaseHandle, { Props as BaseHandleProps } from './Handle';

export const TIME_CONSTRAINT_HANDLE_TYPE = 'time-constraint';

export type Props = Omit<BaseHandleProps, 'type' | 'position'> & {
  taskId: string;
  nodeIsHovered?: boolean;
  nodeIsSelected?: boolean;
};

const TimeConstraintHandle = forwardRef<HTMLDivElement, Props>(
  function Forwarded(allProps, ref): JSX.Element {
    const { id, taskId, nodeIsHovered, nodeIsSelected, ...restProps } =
      allProps;

    return (
      <BaseHandle
        {...restProps}
        id={id}
        ref={ref}
        position={Position.Right}
        type="source"
        data-handletype={TIME_CONSTRAINT_HANDLE_TYPE}
      />
    );
  }
);

export default TimeConstraintHandle;
